import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Shipment from './Shipment';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <Shipment path="shipment/*" />
    </Router>
  </Container>
);
